// UAE Delivery API Key - used for validating booking orders

// Environment-based configuration
const currentEnv = process.env.REACT_APP_ENV;

const getEnvUrls = () => {
  switch (currentEnv) {
    case 'qa':
      return {
        deliveryBaseUrl: 'https://b2c-uae-delivery.qac24svc.dev',
        requestsBaseUrl: 'https://coupon-service-uae.qac24svc.dev',
      };
    case 'staging':
      return {
        deliveryBaseUrl: 'https://stage-b2c-uae-delivery.qac24svc.dev',
        requestsBaseUrl: 'https://stage-coupon-service-uae.qac24svc.dev',
      };
    case 'prod':
      return {
        deliveryBaseUrl: 'https://b2c-uae-delivery.c24.tech',
        requestsBaseUrl: 'https://coupon-service-uae.c24.tech',
      };
    default:
      return {
        deliveryBaseUrl: 'https://b2c-uae-delivery.qac24svc.dev',
        requestsBaseUrl: 'https://coupon-service-uae.qac24svc.dev',
      };
  }
};

const { deliveryBaseUrl, requestsBaseUrl } = getEnvUrls();

// API endpoints
const requestsList = '/v1/coupon-request';
const requestAction = '/action';
const validateBooking = '/api/v1/order';
const couponConfig = '/v1/coupon-request-config/all';
const configParameter = '/v1/coupon-request-config/parameter';
const auditLogs = '/v1/coupon-request-config/audit';

export default (api) => {
  const getCouponRequestUrl = (id) =>
    `${requestsBaseUrl}${requestsList}/${encodeURIComponent(id)}`;

  const getCouponRequestActionUrl = (id) =>
    `${requestsBaseUrl}${requestsList}/${encodeURIComponent(
      id
    )}${requestAction}`;

  const getCouponRequests = (params) => {
    const url = `${requestsBaseUrl}${requestsList}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const getCouponRequestById = (id) => {
    const url = getCouponRequestUrl(id);
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const createCouponRequest = (payload) => {
    const url = `${requestsBaseUrl}${requestsList}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const validateBookingId = (bookingId) => {
    const url = `${deliveryBaseUrl}${validateBooking}`;
    return new Promise((resolve, reject) => {
      api
        .get(
          url,
          { orderIds: bookingId }
          // { 'X-API-KEY': UAE_DELIVERY_API_KEY }
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const updateCouponRequestAction = ({ id, action }) => {
    const url = getCouponRequestActionUrl(id);
    return new Promise((resolve, reject) => {
      api
        .post(url, { action })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const getCouponConfig = () => {
    const url = `${requestsBaseUrl}${couponConfig}`;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const updateCouponConfig = ({ parameter, value }) => {
    const url = `${requestsBaseUrl}${configParameter}/${encodeURIComponent(
      parameter
    )}`;
    return new Promise((resolve, reject) => {
      api
        .put(url, { value: String(value) })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const getCouponConfigAuditLogs = (params) => {
    const url = `${requestsBaseUrl}${auditLogs}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  return {
    getCouponRequests,
    getCouponRequestById,
    createCouponRequest,
    validateBookingId,
    updateCouponRequestAction,
    getCouponConfig,
    updateCouponConfig,
    getCouponConfigAuditLogs,
  };
};

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
